/* eslint-disable */

import React from 'react';
import includes from '../includes';
import boldWrap from '../boldWrap';
import formatLocalCurrency from '../formatLocalCurrency';
import integerWithThousandSeparator from '../integerWithThousandSeparator';
import { filterSectionNames, licenseTypeGroupPlurals } from '../helpersMyCasa/constants';
import { getFilterData } from '../helpersMyCasa';

const getCommercialBuildingLocation = (filter) => {
  const val = !Array.isArray(filter) ? filter.split(',') : filter;
  return val.map((x) => x.replace(/-/g, ' '));
};

const createLabelSentence = (section, activeFilters, clsBold = 'section-title__b tp--b c-txt--secondary') => {
  const filterValues = activeFilters;
  const getFirstValidValue = (types, apx) => types
    .filter((type) => filterValues[`${type}${apx}`])
    .map((type) => filterValues[`${type}${apx}`])[0];

  const labelFrom = 'da';
  const labelTo = 'a';
  const boldCls = clsBold || null;
  let result;

  const createPriceDescr = () => {
    let descr = '';
    if (filterValues.mqpriceMax || filterValues.mqpriceMin) {
      descr = ' al m²';
    } else if (filterValues.paymentMax || filterValues.paymentMin) {
      descr = ' al mese';
    }
    return descr;
  };
  switch (section) {
    case 'channel':
    case 'category':
    case 'propertyTypes':
      // already created
      return null;
    case 'mqprice':
    case 'price': {
      const priceTypes = getFilterData('priceType').values.map(
        (type) => type.value,
      );
      const from = getFirstValidValue(priceTypes, 'Min');
      const to = getFirstValidValue(priceTypes, 'Max');
      const renderCurr = (curr, pfx = '') => (
        <>
          {pfx}
          {' '}
          {boldWrap(formatLocalCurrency(curr, 'it', { withCurrency: true }), boldCls)}
        </>
      );
      const typePrice = createPriceDescr(from, to);
      const tr = filterValues.notrattris ? '(escl. Trattat. riserv.)' : null;
      const isFromOrTo = !!(from || to);
      const isFromAndTo = isFromOrTo && from && to;
      result = ('');

      if (isFromAndTo) {
        result = (
          <>
            {renderCurr(from, labelFrom)}
            {' '}
            {renderCurr(to, labelTo)}
            {' '}
            {typePrice}
            {' '}
            {tr}
          </>
        );
      } else if (from) {
        result = (
          <>
            a partire
            {' '}
            {renderCurr(from, labelFrom)}
            {' '}
            {typePrice}
            {' '}
            {tr}
          </>
        );
      } else if (to) {
        result = (
          <>
            con budget di
            {' '}
            {renderCurr(to)}
            {' '}
            {typePrice}
            {' '}
            {tr}
          </>
        );
      } else if (tr) {
        result = (
          <>
            Prezzo
            {boldWrap(tr, boldCls)}
          </>
        );
      }
      break;
    }
    case 'mq': {
      let from = filterValues.mqMin;
      let to = filterValues.mqMax;
      try {
        from = from ? integerWithThousandSeparator(parseInt(filterValues.mqMin, 10)) : null;
        to = to ? integerWithThousandSeparator(parseInt(filterValues.mqMax, 10)) : null;
      } catch (error) {
        console.log('createLabelSentence', error);
      }

      const isFromOrTo = !!(from || to);
      const isFromAndTo = isFromOrTo && from && to;
      result = ('');
      if (isFromAndTo) {
        result = (
          <>
            da
            {' '}
            {boldWrap(from, boldCls)}
            {' '}
            a
            {' '}
            {boldWrap(`${to} m²`, boldCls)}
          </>
        );
      } else if (from) {
        result = (
          <>
            da almeno
            {' '}
            {boldWrap(`${from} m²`, boldCls)}
          </>
        );
      } else if (to) {
        result = (
          <>
            al massimo
            {' '}
            {boldWrap(`${to} m²`, boldCls)}
          </>
        );
      }
      break;
    }
    case 'rooms': {
      const { numRoomsMin, numRoomsMax } = filterValues;
      const numFrom = numRoomsMin && parseFloat(numRoomsMin);
      const numTo = numRoomsMax && parseFloat(numRoomsMax);
      let from = numFrom;
      let to = numTo;
      try {
        from = from ? integerWithThousandSeparator(parseInt(from, 10)) : null;
        to = to ? integerWithThousandSeparator(parseInt(to, 10)) : null;
      } catch (error) {
        console.log('createLabelSentence', error);
      }
      const sub = 'locale';
      const subs = 'locali';
      const isFromOrTo = !!(numFrom || numTo);
      const isFromAndTo = isFromOrTo && numFrom && numTo;
      result = ('');
      if (isFromAndTo) {
        result = (
          <>
            da
            {' '}
            {boldWrap(from, boldCls)}
            {' '}
            a
            {' '}
            {boldWrap(`${to} ${subs}`, boldCls)}
          </>
        );
      } else if (numFrom) {
        result = (
          <>
            con almeno
            {' '}
            {boldWrap(`${from} ${from > 1 ? subs : sub}`, boldCls)}
          </>
        );
      } else if (numTo) {
        result = (
          <>
            con massimo
            {' '}
            {boldWrap(`${to} ${to > 1 ? subs : sub}`, boldCls)}
          </>
        );
      }

      if (numFrom && numTo && numFrom === numTo) {
        if (numTo === 1) {
          result = (
            <>
              solo
              {' '}
              {boldWrap('Monolocali', boldCls)}
            </>
          );
        } else if (numTo === 2) {
          result = (
            <>
              solo
              {' '}
              {boldWrap('Bilocali', boldCls)}
            </>
          );
        } else if (numTo === 3) {
          result = (
            <>
              solo
              {' '}
              {boldWrap('Trilocali', boldCls)}
            </>
          );
        } else if (numTo === 4) {
          result = (
            <>
              solo
              {' '}
              {boldWrap('Quadrilocali', boldCls)}
            </>
          );
        } else {
          result = (
            <>
              solo
              {' '}
              {boldWrap(`${to} ${subs}`, boldCls)}
            </>
          );
        }
      }

      break;
    }
    case 'numBaths': {
      const value = filterValues.numBaths;
      const label = value > 1 ? 'bagni' : 'bagno';
      result = !!value && (
        <>
          con almeno
          {' '}
          {boldWrap(`${value} ${label}`, boldCls)}
        </>
      );
      break;
    }
    case 'numParkingSpaces': {
      const value = filterValues.numParkingSpaces;
      const label = value > 1 ? 'box / posti auto' : 'box / posto auto';
      result = !!value && (
        <>
          con almeno
          {' '}
          {boldWrap(`${value} ${label}`, boldCls)}
        </>
      );
      break;
    }
    case 'level': {
      const value = filterValues.level;
      const getStrValue = (val) => {
        switch (val) {
          case 'piano terra':
            return (
              <>
                al
                {' '}
                {boldWrap('piano terra', boldCls)}
              </>
            );
          case 'intermedio':
            return (
              <>
                a un
                {' '}
                {boldWrap('piano intermedio', boldCls)}
              </>
            );
          case 'ultimo':
            return (
              <>
                all&quot;
                {' '}
                {boldWrap('ultimo piano', boldCls)}
              </>
            );
          default:
            return '';
        }
      };
      const strVal = getStrValue(value);
      result = !!value
        && (strVal || (
          <>
            dal
            {' '}
            {boldWrap(`${value}° piano in su`, boldCls)}
          </>
        ));
      break;
    }
    case 'lift': {
      const value = filterValues.lift;
      let subValue;

      if (value === true || value === 'true') {
        subValue = (
          <>
            con
            {boldWrap('l\'ascensore', boldCls)}
          </>
        );
      } else if (value === false || value === 'false') {
        subValue = boldWrap('senza ascensore', boldCls);
      } else if (!Number.isNaN(value)) {
        const title = `con ascensore, oltre ${value}° piano`;
        subValue = (
          <span title={title}>
            con
            {' '}
            {boldWrap('ascensore', boldCls)}
            , oltre il
            {' '}
            {boldWrap(`${value}° piano`, boldCls)}
          </span>
        );
      }

      result = !!subValue && subValue;
      break;
    }
    case 'heatingType': {
      const value = filterValues.heatingType || [];
      const getStrValue = (val) => {
        const labelAut = 'autonomo';
        const labelCent = 'centralizzato';
        const inclAut = includes(val, labelAut);
        const inclCent = includes(val, labelCent);
        let res = '';

        if (inclAut && inclCent) {
          res = 'riscaldamento';
        } else if (inclAut) {
          res = 'riscaldamento autonomo';
        } else if (inclCent) {
          res = 'riscaldamento centralizzato';
        }

        return res;
      };
      result = value.length && (
        <>
          con
          {' '}
          {boldWrap(getStrValue(value), boldCls)}
        </>
      );
      break;
    }
    case 'garden': {
      const value = filterValues.garden || [];
      const getStrValue = (val) => {
        const label1 = 'comune';
        const label2 = 'privato';
        const incl1 = includes(val, label1);
        const incl2 = includes(val, label2);
        let res = '';

        if (incl1 && incl2) {
          res = 'giardino';
        } else if (incl1) {
          res = 'giardino comune';
        } else if (incl2) {
          res = 'giardino privato';
        }

        return res;
      };
      result = value.length && (
        <>
          con
          {' '}
          {boldWrap(getStrValue(value), boldCls)}
        </>
      );
      break;
    }

    case 'balconyAndTerrace': {
      const isBalcony = filterValues.balcony;
      const isTerrace = filterValues.terrace;
      const getStrValue = () => {
        let res = '';

        if (isBalcony && isTerrace) {
          res = 'con balcone o terrazzo';
        } else if (isBalcony) {
          res = 'con balcone';
        } else if (isTerrace) {
          res = 'con terrazzo';
        }

        return res;
      };
      result = (isBalcony || isTerrace) && (
        <>
          con
          {' '}
          {boldWrap(getStrValue(), boldCls)}
        </>
      );
      break;
    }
    case 'energyClass': {
      const value = filterValues.energyClass;
      result = !!value && (
        <>
          con
          {' '}
          {boldWrap('classe energetica', boldCls)}
          {' '}
          almeno
          {' '}
          {boldWrap(value, boldCls)}
        </>
      );
      break;
    }
    case 'buildingCondition': {
      const value = filterValues.buildingCondition || [];
      const values = [];
      let subValue;

      if (includes(value, 'nuovo-ristrutturato')) {
        values.push('ottime condizioni');
      }
      if (includes(value, 'abitabile')) {
        values.push('buone condizioni');
      }
      if (includes(value, 'da-ristrutturare')) {
        values.push('da ristrutturare');
      }

      if (values.length) {
        subValue = (
          <>
            in
            {' '}
            {values
              .map((el) => boldWrap(el, `${boldCls} ${el}`))
              .reduce((prev, curr) => (
                <>
                  {prev}
                  ,
                  {' '}
                  {curr}
                </>
              ))}
          </>
        );
      }

      result = subValue;
      break;
    }
    case 'buildingYear': {
      const from = filterValues.buildingYearMin;
      const to = filterValues.buildingYearMax;
      const isFromOrTo = !!(from || to);

      result = ('');
      if (isFromOrTo) {
        let phrase = '';
        if (from && to) {
          phrase = (
            <>
              {' '}
              tra il
              {' '}
              {boldWrap(from, boldCls)}
              {' '}
              e il
              {' '}
              {boldWrap(to, boldCls)}
            </>
          );
        } else if (from) {
          phrase = (
            <>
              {' '}
              a partire dal
              {' '}
              {boldWrap(from, boldCls)}
            </>
          );
        } else if (to) {
          phrase = (
            <>
              {' '}
              entro il
              {' '}
              {boldWrap(to, boldCls)}
            </>
          );
        }
        result = (
          <>
            Costruita
            {phrase}
          </>
        );
      }
      break;
    }
    case 'availability': {
      let value;

      switch (filterValues.availability) {
        case 'occupato':
          value = 'Occupata al rogito';
          break;
        case 'libero':
          value = 'Libera al rogito';
          break;
        case 'nuda proprieta':
        case 'nuda-proprieta':
          value = 'in Nuda Proprietà';
          break;
        case 'affittato':
          value = 'Affittata al rogito';
          break;
        default:
          break;
      }

      result = !!value && boldWrap(value, boldCls);
      break;
    }
    case 'sellerType': {
      const sellers = filterValues.sellerType || [];
      result = sellers.length ? (
        <>
          da
          {' '}
          {sellers
            .map((el) => boldWrap(el, `${boldCls} ${el}`))
            .reduce((prev, curr) => (
              <>
                {prev}
                ,
                {' '}
                {curr}
              </>
            ))}
        </>
      ) : null;
      break;
    }

    case 'photo':
      {
        const { photo } = filterValues;
        if (photo) {
          result = (
            <>
              solo annunci con
              {' '}
              {boldWrap('Foto', boldCls)}
            </>
          );
        }
      }
      break;

    case 'furniture': {
      const { furniture } = filterValues;
      const value = furniture || [];
      const values = {
        none: 'senza arredamento',
        partially: 'solo cucina',
        full: 'arredato',
      };
      if (value.length === 3) {
        result = (
          <>
            {boldWrap('senza arredamento', boldCls)}
            ,
            {' '}
            {boldWrap('con arredamento parziale', boldCls)}
            {' '}
            o
            {' '}
            {boldWrap('con arredamento', boldCls)}
          </>
        );
      } else if (value.length === 2) {
        if (!includes(value, 'none')) {
          result = (
            <>
              {boldWrap('arredato', boldCls)}
              {' '}
              o
              {' '}
              {boldWrap('solo cucina', boldCls)}
            </>
          );
        } else if (includes(value, 'partially')) {
          result = (
            <>
              {boldWrap('senza arredamento', boldCls)}
              {' '}
              o
              {' '}
              {boldWrap('solo cucina', boldCls)}
            </>
          );
        } else {
          result = (
            <>
              con o senza
              {' '}
              {boldWrap('arredamento', boldCls)}
            </>
          );
        }
      } else if (value.length) {
        result = <>{boldWrap(values[value[0]], boldCls)}</>;
      } else {
        result = filterSectionNames[section];
      }
      break;
    }

    case 'air_conditioned': {
      const { air_conditioned: airConditioned } = filterValues;
      if (airConditioned) {
        result = (
          <>
            solo con
            {' '}
            {boldWrap(filterSectionNames[section], boldCls)}
          </>
        );
      }
      break;
    }

    case 'publication_date': {
      const { publication_date: publicationDate } = filterValues;
      const values = {
        '2d': 'ultime 48 ore',
        '7d': 'ultima settimana',
        '30d': 'ultimo mese',
      };

      const articles = {
        '2d': 'nelle ',
        '7d': 'nell\'',
        '30d': 'nell\'',
      };
      if (publicationDate) {
        result = (
          <>
            {articles[publicationDate]}
            {boldWrap(values[publicationDate])}
          </>
        );
      }
      break;
    }
    case 'has_swimming_pool':
      {
        const { has_swimming_pool: hasSwimmingPool } = filterValues;
        if (hasSwimmingPool) {
          result = (
            <>
              solo con
              {' '}
              {boldWrap(filterSectionNames[section], boldCls)}
            </>
          );
        }
      }
      break;

    case 'has_reception':
      {
        const { has_reception: hasReception } = filterValues;
        if (hasReception) {
          result = (
            <>
              solo con
              {' '}
              {boldWrap(filterSectionNames[section], boldCls)}
            </>
          );
        }
      }
      break;
    case 'has_virtual_tour':
      {
        const { has_virtual_tour: hasVirtualTour } = filterValues;
        if (hasVirtualTour) {
          result = (
            <>
              solo con
              {' '}
              {boldWrap(filterSectionNames[section], boldCls)}
            </>
          );
        }
      }
      break;

    case 'is_lux':
      {
        const { is_lux: isLux } = filterValues;
        if (isLux) {
          result = (
            <>
              solo con
              {' '}
              {boldWrap(filterSectionNames[section], boldCls)}
            </>
          );
        }
      }
      break;

    case 'exclude_auction':
      {
        const { exclude_auction: excludeAuction } = filterValues;
        if (excludeAuction) {
          result = (
            <>
              escludi
              {' '}
              {boldWrap(filterSectionNames[section], boldCls)}
            </>
          );
        }
      }
      break;

    case 'is_auction':
      {
        const { is_auction: isAuction } = filterValues;
        if (isAuction) {
          result = (
            <>
              solo
              {' '}
              {boldWrap('immobili all\'asta', boldCls)}
            </>
          );
        } else if (isAuction === false) {
          result = (
            <>
              escludi
              {' '}
              {boldWrap('immobili all\'asta', boldCls)}
            </>
          );
        }
      }
      break;

    case 'exclude_under_construction':
      {
        const { exclude_under_construction: excludeUnderConstruction } = filterValues;
        if (excludeUnderConstruction) {
          result = (
            <>
              escludi
              {' '}
              {boldWrap(filterSectionNames[section], boldCls)}
            </>
          );
        }
      }
      break;
    case 'exclude_private_negotiation':
      {
        const { exclude_private_negotiation: excludePrivateNegotiation } = filterValues;
        if (excludePrivateNegotiation) {
          result = (
            <>
              escludi
              {' '}
              {boldWrap(filterSectionNames[section], boldCls)}
            </>
          );
        }
      }
      break;
      case 'only_private_negotiation':
        {
          const { only_private_negotiation: onlyPrivateNegotiation } = filterValues;
          if (onlyPrivateNegotiation) {
            result = (
              <>
                solo
                {' '}
                {boldWrap(filterSectionNames[section], boldCls)}
              </>
            );
          }
        }
        break;
      
    case 'license_type_groups':
      {
        const { license_type_groups } = filterValues;
        if (license_type_groups && license_type_groups.length) {
          const plurals = licenseTypeGroupPlurals(license_type_groups);
          if (plurals) {
            const last = plurals.pop();
            const start = plurals.join(', ');
            const join = plurals.length > 0 ? ' e ' : '';
            result = (
              <>
                solo
                {' '}
                {boldWrap(`${start}${join}${last}`, boldCls)}
              </>
            );
          }
        }
      }
      break;
    case 'includes_property_ownership':
      {
        const { includes_property_ownership } = filterValues;
        if (includes_property_ownership) {
          result = (
            <>
              solo
              {' '}
              {boldWrap(`${includes_property_ownership === 'true' ? 'con' : 'senza'} mura`, boldCls)}
            </>
          );
        }
      }
      break;
    case 'commercial_building_location':
      {
        const { commercial_building_location } = filterValues;
        if (commercial_building_location) {
          const cblArr = !Array.isArray(commercial_building_location) ? commercial_building_location.split(',') : commercial_building_location;
          const last = cblArr.pop();
          const start = cblArr.join(', ');
          const join = cblArr.length > 0 ? ' e ' : '';
          result = (
            <>
              solo
              {' '}
              {boldWrap(getCommercialBuildingLocation(`${start}${join}${last}`).join(', '), boldCls)}
            </>
          );
        }
      }
      break;

    default:
      break;
  }

  return result || filterSectionNames[section];
};

export default createLabelSentence;
